import { Button } from '@repo/videa-components/src/ui/button';
import { useLocation } from 'react-router';

import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

// Wrapper component for FMX button to use the hook correctly
export const FmxLinkButtonCell = ({ url }: { url: string }) => {
  const location = useLocation();
  const id = location.pathname.split('provider/')[1]?.split('/')[0];
  const { trackEvent } = useTrackEvent();
  const urlPath = url.split('#')?.[1];
  const baseUrl = window.location.origin;

  const fullUrl = `${baseUrl}/#${urlPath}&providerId=${id}`;

  return (
    <Button
      variant="default"
      size="sm"
      onClick={() => {
        window.open(fullUrl, '_blank', 'noopener,noreferrer');
        trackEvent(mixpanelEvents.insightsFMXLinkClick, {
          url: urlPath ? fullUrl : url,
        });
      }}
    >
      <span className="vai-typography-small">View Images</span>
    </Button>
  );
};
